import React from 'react';
import cn from 'classnames';

type ContentWrapperProps = {
	contentClassNames?: string;
	children: React.ReactNode;
};

const ContentWrapper = ({
	contentClassNames,
	children,
}: ContentWrapperProps) => {
	return (
		<div id="content-wrapper" className={cn('d-flex flex-column')}>
			<div id="content" className={cn(contentClassNames)}>
				{children}
			</div>
		</div>
	);
};

export default ContentWrapper;
